import "./ribbon.css"

export default function Ribbon(props) {
  return (
    <div class="corner-ribbon top-right sticky red shadow">{props.text}</div>
  );
}
